export const PRICE = "pr";
export const FILTER = "ft";
export const PAGE = "p";
export const SCONTENT = "scontent";
export const DURATION = "du";
export const LEGACY_DST_PARAM = "dst";
export const COUNTRY_LEGACY = "cy";
export const COUNTRY_PREFIX = "ct";
export const TAGS = "ft";
